var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"epi-picture loaded"},[_c('div',{staticClass:"epi-background-container",style:(_vm.backgroundImageStyle),attrs:{"role":_vm.description ? 'img' : null,"aria-label":_vm.description}})])}
var staticRenderFns = []

export { render, staticRenderFns }